(function () {
'use strict';

angular
    .module('visualGuidelinesRoutes', [
        'styleVisualGuidelinesRoutes',
        'componentVisualGuidelinesRoutes',
        'visualGuidelinesControllers'
    ])
    .config(router);

router.$inject = ['$stateProvider'];

function router($stateProvider) {

    $stateProvider.state('visualGuidelines', {
        url: '/VisualGuideline',
        controller: 'VisualGuidelinesController',
        templateUrl: require('./visualGuidelines.tpl.html')
    });
}
})();